import { render, staticRenderFns } from "./PassThrough.vue?vue&type=template&id=4fdf9b18&"
import script from "./PassThrough.vue?vue&type=script&lang=js&"
export * from "./PassThrough.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports